import React from "react";
import img1 from "../asset/ecommerce-development-company.webp";
import img2 from "../asset/website-designing-company-delhi.webp";
import img3 from "../asset/website-designing-company.webp";
import { NavLink } from "react-router-dom";

const BlogCard = ({ date, title, description, imageUrl }) => {
  return (
    <article className="flex h-full flex-col overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
      <div className="relative">
        <img
          className="aspect-[16/10] w-full object-cover transition-transform duration-300 hover:scale-105"
          src={imageUrl}
          alt="Blog post illustration"
        />
        <span className="absolute bottom-0 left-0 bg-teal-700 px-3 py-1.5 text-xs font-semibold text-white">
          {date}
        </span>
      </div>
      <div className="flex-1 px-6 py-5">
        <h3 className="text-lg font-bold leading-snug text-slate-900">{title}</h3>
        <p className="mt-3 text-sm leading-6 text-slate-600">{description}</p>
      </div>
      <div className="px-6 pt-4 pb-2">
        <NavLink
          to="#"
          className="inline-flex min-h-10 items-center text-sm font-bold text-teal-700 hover:text-teal-900"
        >
          READ MORE
        </NavLink>
      </div>
    </article>
  );
};

const BlogSection = () => {
  const blogs = [
    {
      date: "28 July 2023",
      title:
        "Revolutionizing Online Retail: Ecommerce Website Design in Gurgaon",
      description:
        "In today's digital age, ecommerce has become an integral part of our lives.",
      imageUrl: img1,
    },
    {
      date: "28 July 2023",
      title:
        "Revolutionizing Online Retail: Ecommerce Website Design in Gurgaon",
      description:
        "In today's digital age, ecommerce has become an integral part of our lives.",
      imageUrl: img2,
    },
    {
      date: "28 July 2023",
      title:
        "Revolutionizing Online Retail: Ecommerce Website Design in Gurgaon",
      description:
        "In today's digital age, ecommerce has become an integral part of our lives.",
      imageUrl: img3,
    },
  ];

  return (
    <section className="bg-slate-50 py-16 sm:py-24"><div className="mx-auto max-w-7xl px-5 lg:px-8">
      <p className="text-xs font-bold uppercase tracking-[.2em] text-teal-700">Insights</p><h2 className="mt-3 text-3xl font-bold text-slate-900 sm:text-4xl">
        Latest Blogs
      </h2>
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {blogs.map((blog, index) => (
          <BlogCard key={index} {...blog} />
        ))}
      </div>
    </div></section>
  );
};

export default BlogSection;
